// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ProductCardProps {
	href: {
		url: string
		alt?: string
		isExternal?: boolean
	}
	img?: {
		src?: string
		alt?: string
	}
	name: string
	partNumber?: string
}

export default function ProductCard({
   href,
   img,
   name,
   partNumber
}: ProductCardProps) {
	return (
		<a
			href={href?.url}
			target={href?.isExternal ? '_blank' : undefined}
			className='product-card'
		>

			<div className='product-card__image'>
				{img?.src && (
					<Image
						src={img?.src} // 300x300
						alt={img?.alt}
					/>
				)}
			</div>
			
			<div className='product-card__infos'>

				{isNonWhitespaceString(name) && (
					<p className='product-card__name'>
						{name}
					</p>
				)}

				{isNonWhitespaceString(partNumber) && (
					<p className='product-card__part-number'>
						Part Number: {partNumber}
					</p>
				)}

			</div>

		</a>
	)
}